import ApiService from './apiService';
import { OrgUnitCompensation } from '../models/orgUnitCompensation';

class OrgUnitCompensationService extends ApiService {
  private static instance?: OrgUnitCompensationService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!OrgUnitCompensationService.instance) {
      OrgUnitCompensationService.instance = new OrgUnitCompensationService();
    }
    return OrgUnitCompensationService.instance;
  }

  getOrgUnitCompensations(orgUnitId: string): Promise<OrgUnitCompensation[]> {
    return this.client.get(`/org-units/${orgUnitId}/compensation/all`).then((response) => response.data);
  }

  create(orgUnitId: string, compensation: OrgUnitCompensation): Promise<void> {
    return this.client.post(`/org-units/${orgUnitId}/compensation`, compensation);
  }

  delete(orgUnitId: string, compensationId: number): Promise<void> {
    return this.client.delete(`/org-units/${orgUnitId}/compensation/${compensationId}`);
  }
}

export default OrgUnitCompensationService;
